import { useCallback } from "react";
import { AreaOfPracticeContainer, ArticleTable, PatentSection, SubCategoriesContainer } from "src/components/portal/default/AppListDrawerContent/styles";
import { PracticeAreaData } from "src/dtos/applicationData";

interface AreasOfPracticeProps {
  practiceAreas: PracticeAreaData[]
}

const AreasOfPractice = ({ practiceAreas }: AreasOfPracticeProps) => {
  const getCategory = useCallback((areaIndex: number) => {
    let areas: Array<{ percentage: number, area: string }> = []
    let percentage = 0;

    const selectedArea = practiceAreas[areaIndex]

    if (selectedArea?.types && selectedArea?.types.length > 0) {
      selectedArea.types.forEach(type => {
        areas.push({
          percentage: type.percentage ?? 0,
          area: type.type ?? ''
        })
        percentage += type.percentage ?? 0
      })
    } else {
      areas.push({
        percentage: selectedArea?.percentage ?? 0,
        area: selectedArea?.area ?? ''
      })
      percentage += selectedArea?.percentage ?? 0
    }
    return {
      percentage,
      areas
    }
  }, [practiceAreas])

  return (
    <>
      {practiceAreas?.map((pArea, index) => {
        const { areas, percentage } = getCategory(index);

        return (
          <AreaOfPracticeContainer key={`container-${pArea.area}`}>
            <h4>{`${pArea.area} (${percentage}%)`}</h4>
            <SubCategoriesContainer>
              <ArticleTable>
                <tbody>
                  {areas.map(area => (
                    <tr key={area.area}>
                      <td>{area.percentage}%</td>
                      <td>{area.area}</td>
                    </tr>
                  ))}
                </tbody>
              </ArticleTable>
            </SubCategoriesContainer>
              {pArea.area === 'Intellectual Property' ? (
                <PatentSection>
                  <strong>Does the Applicant utilize patent agents?</strong>
                  <span>{pArea.hasPatentAgents}</span>
                  <strong>Number of patent agents?</strong>
                  <span>{pArea.howManyPatentAgents}</span>
                </PatentSection>
              ) : null}
          </AreaOfPracticeContainer>
        )
      })}
    </>
  )
}

export default AreasOfPractice